import React, { useState } from 'react';
import Paginator from '../../components/common/Paginator/Paginator';

const usePagination = (maxPages: number) => {
  const [page, setPage] = useState(1);

  if (maxPages < page && maxPages > 0) setPage(maxPages);

  const paginator = (
    <Paginator page={page} maxPages={maxPages} setPage={setPage} />
  );

  return { paginator, page };
};

export default usePagination;
